export type LocalAudioFailedScreen = {
  screenName: string;
  screenId: string;
  fileTypes: string[];
};

export type LocalAudioFailedManifest = Record<string, Record<string, LocalAudioFailedScreen[]>>;

export const NO_AUDIO_FOR_SCREEN_MESSAGE = "There is no audio available for this screen";

export function getLocalAudioFailedManifestUrl(packagePath: string): string {
  const base = packagePath.replace(/\/$/, "");
  return `${base}/audio/_failed.json`;
}

export function getLocalAudioBaseUrl(packagePath: string): string {
  const base = packagePath.replace(/\/$/, "");
  return `${base}/audio`;
}

export function parseFailedLessonIds(manifest: LocalAudioFailedManifest): Set<string> {
  const ids = new Set<string>();
  for (const chapter of Object.values(manifest ?? {})) {
    for (const screens of Object.values(chapter ?? {})) {
      for (const screen of screens ?? []) {
        if (screen?.screenId) {
          ids.add(screen.screenId);
        }
      }
    }
  }
  return ids;
}

export function isLessonAudioFailed(screenId: string, failedScreenIds: Set<string>): boolean {
  return failedScreenIds.has(screenId);
}

export async function probeLocalCourseAudio(
  packagePath: string,
): Promise<{ enabled: boolean; failedScreenIds: Set<string> }> {
  if (!packagePath) {
    return { enabled: false, failedScreenIds: new Set() };
  }

  const url = getLocalAudioFailedManifestUrl(packagePath);
  try {
    const res = await fetch(url);
    if (!res.ok) {
      return { enabled: false, failedScreenIds: new Set() };
    }
    const data = (await res.json()) as LocalAudioFailedManifest;
    if (!data || typeof data !== "object" || Array.isArray(data)) {
      return { enabled: false, failedScreenIds: new Set() };
    }
    return { enabled: true, failedScreenIds: parseFailedLessonIds(data) };
  } catch {
    return { enabled: false, failedScreenIds: new Set() };
  }
}

export function localLessonJsonUrl(localAudioBaseUrl: string, lessonId: string): string {
  return `${localAudioBaseUrl.replace(/\/$/, "")}/${lessonId}.json`;
}

export function localLessonOpusUrl(localAudioBaseUrl: string, lessonId: string): string {
  return `${localAudioBaseUrl.replace(/\/$/, "")}/${lessonId}.opus`;
}
